import { ISearchable } from './Searchable.itf'

/**
* @typedef  PreparationConstructor
* @type {object}
* @property {string} nom - the nom value
* @property {Object} idPreparation - the idPreparation value

* */
export class Preparation extends ISearchable {
  /**
   * Creates an instance of Preparation.
   * @memberof Preparation
   * */
  constructor(object) {
    super()
    this.nom = object.nom
    this.idPreparation = object.idPreparation
  }

  formatToDisplay() {
    this.nom = this.nom.charAt(0).toUpperCase() + this.nom.substring(1).toLowerCase()
    this.raccourci = this.nom
    this.lineClassName = 'prepaLine'
    this.boxClassName = 'prepaBox'
    this.displayType = 'Préparation'
    this.created = true
    return this
  }

  formatToCreate() {
    this.formatToDisplay()
    this.created = false
    this.lineClassName = 'create-prepaLine'
    return this
  }

  getIdAttribute() {
    return 'idPreparation'
  }

  getNameAttribute() {
    return 'nom'
  }

  getRaccourciAttribute() {
    return 'raccourci'
  }
}
